export const agentRequestInputProps = {
  variant: "outlined",
  size: "md",
  color: "blue-gray",
  className: "!rounded-xl !border !border-app-border !border-t-app-border bg-app-surface !text-app-text placeholder:!text-app-text-subtle placeholder-shown:!border-app-border placeholder-shown:!border-t-app-border focus:!border focus:!border-app-focus focus:!border-t-app-focus",
  labelProps: {
    className: "!hidden before:!hidden after:!hidden",
  },
  containerProps: {
    className: "min-w-0",
  },
};

export const agentRequestFieldClass = "flex w-full flex-col gap-2";

export function AgentRequestFieldLabel({htmlFor, children}) {
  return (
    <label htmlFor={htmlFor} className="px-1 text-sm font-medium text-app-text-muted">
      {children}
    </label>
  );
}

export const agentRequestPrimaryButtonClass =
  "rounded-xl bg-app-primary px-6 py-3 text-app-on-primary shadow-none hover:shadow-md";

export const agentRequestSecondaryButtonClass =
  "rounded-xl border-app-border px-6 py-3 text-app-text shadow-none";
